import React from 'react'
import PropTypes from 'prop-types'

import FieldsLayerContainer from '../../containers/LayersContainers/FieldsLayerContainer'
import GroupDeliverablesLayerContainer from '../../containers/LayersContainers/GroupDeliverablesLayerContainer'
import TemporalGroupComparisonLayerContainer from '../../containers/LayersContainers/TemporalGroupComparisonLayerContainer'
import MeasureToolsLayerContainer from '../../containers/LayersContainers/MeasureToolsLayerContainer'
import { ProspectLayersContainer } from '../../containers/LayersContainers/ProspectLayersContainer'
import SeasonLayersContainer from '../../containers/LayersContainers/SeasonLayersContainer'
import SamplesLayerContainer from '../../containers/LayersContainers/SamplesLayerContainer'
import GlobalLayersContainer from '../../containers/LayersContainers/GlobalLayersContainer'
import ClusterLayerContainer from '../../containers/LayersContainers/ClusterLayerContainer'

import { CLUSTER_ZOOM_THRESHOLD } from '@layers-frontend/commons/constants'
import OlMap from 'ol/Map'
import { MapLayerProvider } from './contexts/MapLayerProvider'

const MapLayers = ({ visible, zoomLevel, map, isMapZoomReady }) => {
  if (!visible) return null

  return (
    <MapLayerProvider map={map}>
      <div id="MapLayers">
        <FieldsLayerContainer />
        <SeasonLayersContainer />
        <SamplesLayerContainer />
        <GroupDeliverablesLayerContainer />
        <TemporalGroupComparisonLayerContainer />
        <MeasureToolsLayerContainer />
        <ProspectLayersContainer />
        {Number.parseFloat(zoomLevel).toFixed(1) >= CLUSTER_ZOOM_THRESHOLD && isMapZoomReady && <GlobalLayersContainer />}
        {Number.parseFloat(zoomLevel).toFixed(1) < CLUSTER_ZOOM_THRESHOLD && <ClusterLayerContainer />}
      </div>
    </MapLayerProvider>
  )
}

MapLayers.propTypes = {
  visible: PropTypes.bool,
  zoomLevel: PropTypes.number.isRequired,
  map: PropTypes.instanceOf(OlMap).isRequired
}

export default MapLayers
